module.exports = __webpack_public_path__ + "78af4f5a284a947605ddee2acee621cb.png";